// AUTO-GENERATED by scripts/gen-build-info.js — do not edit.
export const BUILD_INFO = { sha: 'b55c91d2', builtAt: '2026-10-23 15:43 UTC' };
